import { schema } from 'normalizr'

import Model from './model'

class AiIntegration extends Model({
  id: undefined,
  name: undefined,
  createdAt: undefined,
  slug: undefined,
  model: undefined,
  description: undefined,
  initialPrompt: undefined,
  temperature: undefined,
  maxTokens: undefined,
  frequencyPenalty: undefined,
  presencePenalty: undefined,
  reasoningEffort: undefined,
  extended_text: undefined,
  service: undefined,
  tokenApi: undefined,
  statusApi: undefined,
  errorApi: undefined,
  isActive: undefined,
  modifiedBy: undefined,
}) {}

const aiIntegrationNewSchema = new schema.Entity(
  'aiAssistant',
  {},
  {
    processStrategy: entity => {
      return new AiIntegration(entity)
    },
  }
)

const aiIntegrationSchema = [aiIntegrationNewSchema]

export { aiIntegrationSchema, AiIntegration as default }

const aiCorrectionEntity = new schema.Entity('aiCorrection')
export const aiCorrectionSchema = [aiCorrectionEntity]

const aiModelEntity = new schema.Entity('aiModel')
export const aiModelSchema = [aiModelEntity]
